var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreedot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.9999C10 13.1025 10.8973 13.9998 11.9999 13.9998C13.1025 13.9998 13.9998 13.1025 13.9998 11.9999C13.9998 10.8973 13.1025 10 11.9999 10C10.8973 10 10 10.8973 10 11.9999ZM10 18.6663C10 19.7689 10.8973 20.6662 11.9999 20.6662C13.1025 20.6662 13.9998 19.7689 13.9998 18.6663C13.9998 17.5637 13.1025 16.6664 11.9999 16.6664C10.8973 16.6664 10 17.5637 10 18.6663ZM10 5.33353C10 6.43615 10.8973 7.33345 11.9999 7.33345C13.1025 7.33345 13.9998 6.43615 13.9998 5.33353C13.9998 4.23091 13.1025 3.33362 11.9999 3.33362C10.8973 3.33362 10 4.23091 10 5.33353Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot);
export default __webpack_public_path__ + "static/media/threedot.ea0ea24cce966f671b72f5d708aace1d.svg";
export { ForwardRef as ReactComponent };